import { ValidationStrategyFactory } from "./validation-strategy.factory";
import { ValidationStrategy } from "./validation.strategy";

export class CompanyValidationStrategy extends ValidationStrategy {

    private errorMessage = "";

    public validate(): boolean {
        let isValid = true;

        if (this.isRequired && !this.isDisabled && !this.isHidden) {
            this.addToOptionInjection({
                key: "Required",
                value: "true",
                type: "Boolean"
            })

            this.attribute.attributes.forEach(childAttribute => {
                let validator = ValidationStrategyFactory.create(childAttribute, this.injectedOptions);
                let childrenAreValid = validator.validate();

                if(!childrenAreValid) {
                    this.errorMessage += `${validator.getErrorMessage()}\n`;
                }

                isValid = childrenAreValid && isValid;
            });
        }

        return isValid
    }

    public getErrorMessage(errorType: string = "error"): string {
        if(this.errorMessage) {
            return this.errorMessage;
        } else {
            return super.getErrorMessage(errorType);
        }
    }
}